<script>

export default {
  name: 'GoogleStoreMapComponent',
  props: {
    mapData: {
      type: Object,
      required: true,
    },
    sizeWidth: {
      type: String,
      required: true,
    },
    sizeHeight: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <section data-ui="store-map-component">
    <a
      :id="`store-map-${mapData.normalizedName}`"
      class="google-canvas-map static-map cdr-hide@xs-only"
      :href="mapData.directionLink"
      target="_blank"
      :rel="`Go to store ${mapData.normalizedName}`"
    >
      <img
        :src="mapData.googleApiUrl"
        :alt="`Location for the store ${mapData.normalizedName}`"
        class="static-map__image"
      >
    </a>
  </section>
</template>

<style scoped lang="scss">
.static-map {
  width: 100%;
  height: 100%;
  display: block;

  &__image {
    height: auto;
    position: absolute;
    top: 0;
    width: 100%;
  }
}
</style>
